import { useCountdown } from 'hooks/interval';
import type React from 'react';

type CountdownChildren = (props: {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}) => React.ReactNode;

export interface CountdownProps {
  children: CountdownChildren;
  timeLeft: number;
  dual?: boolean;
}

export const Countdown = ({ children, timeLeft, dual }: CountdownProps) => {
  const [countdown] = useCountdown(0, timeLeft);

  const parts = [
    Math.floor(countdown / (3600 * 24)),
    Math.floor((countdown % (3600 * 24)) / 3600),
    Math.floor((countdown % 3600) / 60),
    Math.floor(countdown % 60),
  ].map((part) => (part < 10 ? `${dual ? '0' : ''}${part}` : `${part}`));

  return (
    <>
      {children({
        days: parts[0],
        hours: parts[1],
        minutes: parts[2],
        seconds: parts[3],
      })}
    </>
  );
};
